import { Component, ViewChild } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { MergePersonaModalComponent } from '../../lib/merge-persona-modal/merge-persona-modal.component'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'

const exampleHtml = `
<div class="docs-example-line">Keep Persona: {{ keepProfile.persona.full_name }}</div>
<div class="docs-example-line">Merge Persona: {{ mergeProfile.persona.full_name }}</div>
<button (click)="open()">Merge Personas</button>
<se-po-merge-persona-modal #mergePersonaModal
  (personaMerged)="onPersonaMerge($event)">
</se-po-merge-persona-modal>
`

const exampleTypescript = `
import { Component, ViewChild } from '@angular/core'
import { MergePersonaModalComponent } from '../../lib/merge-persona-modal/merge-persona-modal.component'
import { Persona, Profile } from '@se-po/shared-data-access-models'

export class MergePersonaModalChildExampleComponent implements OnInit {
  @ViewChild('mergePersonaModal') public mergePersonaModal: MergePersonaModalComponent

  public keepProfile: UserProfile = {
    access: 'owner',
    id: 'test-id',
    persona: {
      id: 5,
      first_name: 'Carl',
      last_name: 'McMansion',
      full_name: 'Carl McMansion',
      date_of_birth: '2000-01-21',
      gender: 'male',
      graduation_year: '2020',
      email_addresses: [{ address: 'test@test.com', id: 10}],
    },
    relationship: 'other'
  }

  public mergeProfile: UserProfile = {
    access: 'owner',
    id: 'test2-id',
    persona: {
      id: 6,
      first_name: 'James',
      last_name: 'McMansion',
      full_name: 'James McMansion',
      date_of_birth: '2000-01-21',
      gender: 'male',
      graduation_year: '2020',
      email_addresses: [{ address: 'test1@test.com', id: 101 }]
    },
    relationship: 'other'
  }

  public open(): void {
    this.mergePersonaModal.open(this.keepProfile, this.mergeProfile, 'from_modal')
  }

  public onPersonaMerge(profile: Profile): void {
    console.log(\`Persona \${profile.persona.full_name\} merged\`)
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-merge-persona-modal-example',
  template,
  styleUrls: ['./merge-persona-modal-docs.component.scss'],
  standalone: false,
})
export class MergePersonaModalExampleComponent extends SeFeDocsExampleComponent {
  @ViewChild('mergePersonaModal') public mergePersonaModal: MergePersonaModalComponent
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public keepProfile: UserProfile = {
    access: 'owner',
    id: 'test-id',
    persona: {
      id: 5,
      first_name: 'Carl',
      last_name: 'McMansion',
      full_name: 'Carl McMansion',
      date_of_birth: '2000-01-21',
      gender: 'male',
      graduation_year: '2020',
      email_addresses: [{ address: 'test@test.com', id: 10}],
    },
    relationship: 'other'
  }

  public mergeProfile: UserProfile = {
    access: 'owner',
    id: 'test2-id',
    persona: {
      id: 6,
      first_name: 'James',
      last_name: 'McMansion',
      full_name: 'James McMansion',
      date_of_birth: '2000-01-21',
      gender: 'male',
      graduation_year: '2020',
      email_addresses: [{ address: 'test1@test.com', id: 101 }]
    },
    relationship: 'other'
  }

  constructor(
  ) {
    super()
  }

  public open(): void {
    this.mergePersonaModal.open(this.keepProfile, this.mergeProfile, 'from_modal')
  }

  public onPersonaMerge(profile: UserProfile): void {
    console.log(`Persona ${profile.persona.full_name} merged`)
  }
}
